import { IAction } from '../../../__core/Interfaces/IAction';
import COURSE_INSTANCE_ACTIONS from '../Actions/ActionTypes';
import { instanceAccessForStudentsInitState } from './CourseInstanceInitState';
import { InstanceAccessResponse } from '../Types/InstanceAccessResponse';

export const instanceAccessForStudentsReducer = (
  state: InstanceAccessResponse = instanceAccessForStudentsInitState,
  action: IAction<InstanceAccessResponse>
): InstanceAccessResponse => {
  switch (action.type) {
    case COURSE_INSTANCE_ACTIONS.FETCH_INSTANCE_ACCESS_FOR_STUDENTS:
      return { ...action.payload };

    default:
      return state;
  }
};
